<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_xii"></a><a id="page_xiii"></a><a id="acknowledgments"></a><strong>Acknowledgments</strong></h2>
<p class="indent">Learned something about ideas from just about everybody I ever taught or worked with. Any attempt to remember and name them all would fail. A sincere but sweeping “Thank you, everyone” must therefore suffice.</p>
<p class="indent">Special thanks go to Tom Pflimlin, whose many suggestions helped me improve the first edition of this work; to Henry Caroselli and Mel Sant, whose many suggestions helped me improve this second edition; to Steven Piersanti and his staff, whose enthusiasm and knowledge and skill helped me transform a rough manuscript into a finished book, and a successful first edition into an even better second edition; and to my family, whose faith sustains me.</p>
<p class="image"><a id="page_xiv"></a><img alt="Image" src="images/f0xiv-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?3037e44d